import { render, staticRenderFns } from "./add_companies_page.vue?vue&type=template&id=e30d1728"
import script from "./add_companies_page.vue?vue&type=script&lang=js"
export * from "./add_companies_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports